import React, { useState, useEffect, useRef } from "react"
import { Link, withRouter, useHistory } from "react-router-dom"
import PropTypes from 'prop-types'
import { Modal, Toggle } from "rsuite"
import Swal from "sweetalert2"
import {
	Button,
	Card,
	CardBody,
	Col,
	Form,
	Input,
	Label,
	Row
} from "reactstrap"
import SelectPickerPaginate from "components/Filters/SelectPickerPaginate"

//GraphQL
import {  Insert_Sub_Categories_One,  Insert_Sub_Category_One,  Insert_Sub_Service_One,  Update_Sub_Category_One,  Update_Sub_Service_One } from "gql/Mutation"
import {   ServiceCategoryList } from "gql/query"
import { useMutation } from "@apollo/client"

//Import Breadcrumb
import FileUploader from "components/Common/FileUploader"

const EcommerceCreateSubServices = (props) => {
 	const history = useHistory()
	const [CreateSubServiceMutation] = useMutation(Insert_Sub_Service_One)
	const [UpdateSubServiceMutation] = useMutation(Update_Sub_Service_One)
	const [name, setName] = useState("")
	const [category, setCategory] = useState("")
	const [btnLoading, setBtnLoading] = useState(false)
	const [isActive, setActive] = useState(true)

	const handleCreateSubCategory = async (e) => {
		try {
			e.preventDefault()
			setBtnLoading(true)
			let user = JSON.parse(localStorage.getItem("authUser"))
			if (user?.user?.id) {
				if (props.subcategory?.id) {
					await UpdateSubServiceMutation({
						variables: {
							id: props.subcategory?.id,
							object: {
								service_name:name,
								service_category_id: category,
								active: isActive
							}
						}
					})
				} else {
					await CreateSubServiceMutation({
						variables: {
							object: {
								service_name:name,
								// sort_order: 0,
								service_category_id: category,
								created_by: user?.user?.id,
								updated_by: user?.user?.id
							}
						},
					})
				}
				Swal.fire(`Sub Category ${props.subcategory?.id ? "Updated" : "Created"} Successfully`, "", "success").then(() => {
					props.onSubmit()
					props.close()
				})
			}

		} catch (err) {
			Swal.fire("Something went wrong", "", "error")
		} finally {
			setBtnLoading(false)
		}
	}
	useEffect(() => {
		if (props.subcategory?.id) {
			setName(props.subcategory.service_name)
			setCategory(props.subcategory.service_category_id)
			setActive(props.subcategory.active)
		} else {
			setName("")
			setCategory("")
		}
	}, [props.subcategory])
	return (
		<Modal open={props.open} onClose={() => props.close()}>
			<Modal.Header>
				<Modal.Title>{props.subcategory?.id ? "Update Sub Service" : "Create Sub Service"}</Modal.Title>
			</Modal.Header>
			<Row>
				<Col xs="12">
					<Card>
						<CardBody>
							<Form id="subcategoryform" onSubmit={handleCreateSubCategory}>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="subcategory_name">Sub Service Name</Label>
											<Input
												id="subcategory_name"
												name="subcategory_name"
												defaultValue={name}
												type="text"
												className="form-control"
												onChange={(e) => setName(e.target.value)}
												required
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="category_group">Service</Label>
											<br />
											<SelectPickerPaginate
												query={ServiceCategoryList}
												placeholder="Select Service"
												value={category}
												onChange={setCategory}
												arrKey="service_categories"
												objectLabel="category"
												objectValue="id"
												style={{ width: "100%" }}
												paginate={true}
												filterCondition={null}
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col sm="12">
										<div className="mb-3">
											<Label htmlFor="commission_percentage">Active</Label>
											<Toggle 
												checked={isActive}
												onChange={(checked)=>setActive(checked)}
												style={{marginLeft: "1rem"}}
											/>
										</div>
									</Col>
								</Row>
								<div className="d-flex flex-wrap gap-2">
									<Button
										color="primary"
										className="btn "
										type="submit"
										disabled={btnLoading}
									>
										Submit
									</Button>
									<Button
										type="button"
										color="secondary"
										className=" "
										onClick={(e) => props.close()}
									>
										Cancel
									</Button>
								</div>
							</Form>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Modal>
	)
}
EcommerceCreateSubServices.propTypes = {
	open: PropTypes.bool,
	close: PropTypes.func,
	onSubmit: PropTypes.func,
	subcategory: PropTypes.any
}
export default withRouter(EcommerceCreateSubServices)
